import script from "./LuckyWheel.vue?vue&type=script&setup=true&lang=js"
export * from "./LuckyWheel.vue?vue&type=script&setup=true&lang=js"

import "./LuckyWheel.vue?vue&type=style&index=0&id=565093d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565093d2"]])

export default __exports__